// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__vd4sV","itemTitle":"ClientEmergencyInfo_itemTitle__3NEn9","itemText":"ClientEmergencyInfo_itemText__2xFfw"};